
import {IUserLogEntryBuilder} from './i.user.log.entry.builder';
import {IUserLogEntryOptions} from './i.user.log.entry.options';

/**
 *
 * @class FindSidingParkingBuilder
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      May 2021
 *
 */
export class FindSidingParkingBuilder implements IUserLogEntryBuilder {

  /** convert raw MongoDB user log entry into data that can construct a tree node */
  build(data: any, args: IUserLogEntryOptions): any {

    const u:      string = data._id.match(/^find-siding-parking-(.*)/i)[1];

    return {
      id:              data._id,
      seq:             parseInt(data.seq),
      name:            `Find Siding in: [${data.l.k}] ${data.l.n} for: ${data.tr.n} ${data.tr.d}`,
      hasChildren:     args.hasChildren,
      isExpanded:      args.isExpanded,
      type:            'find-siding-park',
      children:        args.children,
      parent:          args.parent,
      kids:            data.ch,
      tags:            data.tg,
      label:           data.lb,
      pkey:            data.pa,
      kind:            data.l.k,
      sIndex:          data.l.sx,
      index:           data.l.ix,
      u:               data._id
    };

  }
}
